import React from 'react';

import { Provider } from "react-redux";
import { useLocation } from "react-router-dom";

import SentUpdateContainer from "./container/SentUpdateContainer";

import configure from '../../store/configure';
import Layout from "../../component/layout/Layout";

const SentUpdatePage = () => {

    const path = useLocation().pathname.split("/");
    const uid = path[3];

    return (
        <Provider store={configure}>
            <Layout>
                <SentUpdateContainer
                    uid={uid}
                />
            </Layout>
        </Provider>
    );
};

export default SentUpdatePage;
